import { createContext } from "react";

export const ModalPopupContext = createContext<{
    host: HTMLElement | null;
    setOpen: (owner: object, open: boolean, close?: () => void) => void;
} | null>(null);
